import {
  Box,
  Button,
  Chip,
  formatDate,
  formatMinutes,
  Grid,
  ListContainer,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  UpdateIconButton,
} from "@compass/core";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  StaffServiceListDto,
  StaffServiceListFilter,
  StaffServiceListResource,
} from "generated/openApi";
import { useList, useRouter } from "hooks";
import "moment-timezone";
import { staffServicePageRoute } from "pages/staff/staff-services/StaffServicePage/StaffServicePage";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const Services = (props: { initialLoad: boolean; staffId: number; onGetList: () => void }) => {
  const ROOT_PERMISSION: Permission = Permission.StaffService;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const [listFilter, setListFilter] = useState<StaffServiceListFilter>({
    serviceFilter: { staffId: props.staffId },
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
    sortObjects: [{ property: pn<StaffServiceListDto>("date"), isDesc: true }],
  });
  const [listItems, setListItems] = useState<StaffServiceListDto[]>([]);
  const [resource, setResource] = useState<StaffServiceListResource>({});
  const properties = resource.properties || [];

  const { tableContainerRef, loadList, applySort } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.staffServices.getList(listFilter).then((response) => {
        setListItems(response);
      });
    },
  });

  useEffect(() => {
    if (props.initialLoad) {
      loadList(listFilter);

      ApiService.staffServices.getListResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialLoad]);

  const header = (
    <Stack direction="row" justifyContent="space-between">
      <Box></Box>
      <Stack direction="row" alignItems="center" spacing="sm">
        {/* {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
          <Button
            onClick={() =>
              navigate({
                pathname: staffServicePageRoute.getPath({
                  id: 0,
                  crudMode: "edit",
                  screenType: "dialog",
                }),
                search: staffServicePageRoute.getOptionalParams?.({
                  staffId: props.staffId,
                  hideStaff: true,
                }),
              })
            }
            variant="outlined"
          >
            + New
          </Button>
        )} */}
      </Stack>
    </Stack>
  );

  return (
    <>
      <ListContainer
        fullHeight
        // header={header}
        tableContainer={
          <TableContainer ref={tableContainerRef}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <ListBeProperty
                      listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("date"))}
                      sortObjects={listFilter.sortObjects}
                      onChange={(sortObjects) => applySort(sortObjects)}
                    />
                  </TableCell>
                  <TableCell>
                    <ListBeProperty
                      listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("serviceType"))}
                      sortObjects={listFilter.sortObjects}
                      onChange={(sortObjects) => applySort(sortObjects)}
                    />
                  </TableCell>
                  <TableCell>
                    <ListBeProperty
                      listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("serviceName"))}
                      sortObjects={listFilter.sortObjects}
                      onChange={(sortObjects) => applySort(sortObjects)}
                    />
                  </TableCell>
                  <TableCell>
                    <ListBeProperty
                      listProperty={properties.find(
                        (x) => x.propertyName === pn<StaffServiceListDto>("durationInMinutes")
                      )}
                      sortObjects={listFilter.sortObjects}
                      onChange={(sortObjects) => applySort(sortObjects)}
                    />
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listItems.map((listItem) => (
                  <TableRow
                    key={listItem.id}
                    onClick={() =>
                      navigate({
                        pathname: staffServicePageRoute.getPath({
                          id: listItem.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                        search: staffServicePageRoute.getOptionalParams?.({
                          staffId: props.staffId,
                          hideStaff: true,
                        }),
                      })
                    }
                  >
                    <TableCell>{formatDate(listItem.date)}</TableCell>
                    <TableCell>{listItem.serviceType}</TableCell>
                    <TableCell>{listItem.serviceName}</TableCell>
                    <TableCell>{formatMinutes(listItem.durationInMinutes)}</TableCell>
                    <TableCell type="action">
                      {isAuthorized(ROOT_PERMISSION, PermissionAction.Update) && (
                        <UpdateIconButton
                          onClick={() =>
                            navigate({
                              pathname: staffServicePageRoute.getPath({
                                id: listItem.id,
                                crudMode: "edit",
                                screenType: "dialog",
                              }),
                              search: staffServicePageRoute.getOptionalParams?.({
                                staffId: props.staffId,
                                hideStaff: true,
                              }),
                            })
                          }
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      <ListContext.Provider
        value={{
          loadList: (options) => {
            loadList(listFilter, { resetPage: options?.resetPage });
            props.onGetList();
          },
        }}
      >
        {matchTemplatePath(staffServicePageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );
};
